import React, { useRef } from 'react';
import { useDrag } from 'react-dnd';
import { Box } from '@ghq-abi/design-system-v2';

import { DraggableProps } from './types';

export function Draggable<T>({ item, children }: DraggableProps<T>) {
  const ref = useRef<HTMLDivElement>(null);
  const [{ isDragging }, dragRef] = useDrag({
    type: item.type,
    item,
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  dragRef(ref);

  return (
    <Box ref={ref} className={isDragging ? 'cursor-grabbing' : 'cursor-grab'}>
      {children}
    </Box>
  );
}
